import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerService } from './ServerService';

@Injectable({
  providedIn: 'root'
})
export class SuporteTicketsService extends ServerService {
  private endpoint = '/suporte-tickets';

  constructor(protected http: HttpClient) {
    super(http);
  }

  liste(filtro: any = {}): Promise<any> {
    return this.obtenha(this.endpoint, filtro);
  }

  listeAbertosEmpresa(empresaId: number): Promise<any[]> {
    return this.obtenha(`${this.endpoint}/empresa/${empresaId}/abertos`, {});
  }

  listeAbertosContato(contatoId: number): Promise<any[]> {
    return this.obtenha(`${this.endpoint}/contato/${contatoId}/abertos`, {});
  }

  obtenhaTicket(ticketId: number): Promise<any> {
    return this.obtenha(`${this.endpoint}/${ticketId}`, {});
  }

  crie(ticket: any): Promise<any> {
    return this.facaPost(this.endpoint, ticket);
  }

  atualize(ticket: any): Promise<any> {
    return this.facaPut(`${this.endpoint}/${ticket.id}`, ticket);
  }

  altereResponsavel(ticketId: number, responsavelUsuarioId: number): Promise<any> {
    return this.facaPost(`${this.endpoint}/${ticketId}/responsavel`, { responsavelUsuarioId });
  }

  assuma(ticketId: number): Promise<any> {
    return this.facaPost(`${this.endpoint}/${ticketId}/assumir`, {});
  }

  mudeStatus(ticketId: number, status: string, observacao?: string): Promise<any> {
    const dados: any = { status };

    if (observacao && status === 'RESOLVIDO') {
      dados.resolucao = observacao;
    }

    if (observacao && status === 'CANCELADO') {
      dados.justificativaCancelamento = observacao;
    }

    return this.facaPost(`${this.endpoint}/${ticketId}/status`, dados);
  }

  adicioneInteracao(ticketId: number, texto: string, tipo: string = 'COMENTARIO'): Promise<any> {
    return this.facaPost(`${this.endpoint}/${ticketId}/interacoes`, { texto, tipo });
  }

  adicioneAnexo(ticketId: number, arquivo: File): Promise<any> {
    const formData = new FormData();
    formData.append('files', arquivo, arquivo.name);

    return this.http.post(`${this.endpoint}/${ticketId}/anexos`, formData)
      .toPromise()
      .then(this.retorno)
      .catch(this.handleError);
  }

  listeResponsaveis(): Promise<any[]> {
    return this.obtenha(`${this.endpoint}/responsaveis`, {});
  }

  painelGestor(): Promise<any> {
    return this.obtenha(`${this.endpoint}/painel-gestor`, {});
  }
}
